import { createSlice } from '@reduxjs/toolkit';

// Persisted skin-analysis state. Raw capture frames are NOT stored here (too big
// for localStorage); only the small results payload (findings + a downscaled
// annotated photo + landmarks for the hotspots) and the saved plan are kept.
const initialState = {
  intake: {},
  includeTanning: true,
  results: null, // { findings, summary, engine, photo, keypoints, createdAt }
  plan: null,    // { createdAt, productSkus, reminders }
  history: [],   // [{ createdAt, summary, topConcerns }]
  resumeTo: null, // post-auth redirect target (e.g. back to results after sign-up)
};

const skinAnalysisSlice = createSlice({
  name: 'skinAnalysis',
  initialState,
  reducers: {
    setIntake: (state, action) => {
      const a = action.payload || {};
      state.intake = a;
      // Tanning products are offered based on the tan-goal answer (not a toggle).
      state.includeTanning = !!(a.tanGoal && a.tanGoal !== 'none');
    },
    setIncludeTanning: (state, action) => {
      state.includeTanning = !!action.payload;
    },
    setResults: (state, action) => {
      state.results = action.payload;
      if (action.payload) {
        state.history.unshift({
          createdAt: action.payload.createdAt,
          summary: action.payload.summary,
          topConcerns: (action.payload.findings || []).slice(0, 3).map((f) => f.concernId),
        });
        state.history = state.history.slice(0, 10);
      }
    },
    savePlan: (state, action) => {
      state.plan = action.payload;
    },
    clearResults: (state) => {
      state.results = null;
    },
    setResumeTo: (state, action) => {
      state.resumeTo = action.payload;
    },
    clearResumeTo: (state) => {
      state.resumeTo = null;
    },
  },
});

export const {
  setIntake,
  setIncludeTanning,
  setResults,
  savePlan,
  clearResults,
  setResumeTo,
  clearResumeTo,
} = skinAnalysisSlice.actions;

export default skinAnalysisSlice.reducer;
